module.exports = __webpack_public_path__ + "img/159.2ff8afb1.jpg";